import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const label: SxStyle = {
  fontSize: (p) => p.typography.h5,
  color: (p) => p.palette.primary[600],
};

export const button: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  px: 4.5,
};
